import React from 'react'

const Loopse = () => {
    return (
        <div className='container'>
            <h1>Loops in C++</h1>
            <p>In computer programming, loops are used to repeat a block of code.</p>
            <br />
            <p>For example, let's say we want to show a message 100 times. Then instead of writing the print 
                statement 100 times, we can use a loop.</p> <br />
            <p>That was just a simple example; we can achieve much more efficiency and sophistication in our 
                programs by making effective use of loops</p> <br />
            <p>There are 3 types of loops in C++.</p>
            <ul>
                <li><strong>for </strong> Loop</li>
                <li><strong>While</strong> Loop</li>
                <li><strong>do..While</strong> Loop</li>
            </ul>
            <br /> <br />
            <h3>For loop</h3>
            <p>The syntax of for-loop is:</p>
            <div className='containers'>
            <code className='keywords'> for</code> (<code className='plain'>initialization; condition; update</code> )
            <br /> &#123;
             <div className='comment'>// body of-loop </div>  
&#125;
            </div>
            <br />
            <p>Here, <br />
            <ul>
	<li><code>initialization</code> - initializes variables and is executed only once</li>
	<li><code>condition</code> - if <code>true</code>, the body of <code>for</code> loop is executed<br/>
		if <code>false</code>, the for loop is terminated</li>
	<li><code>update</code> - updates the value of initialized variables and again checks the condition</li>
</ul>
<h1>Example 1: Printing plains From 1 to 5</h1>
<code class="cpp "><span class="library">#<span class="keywords">include</span> <span class="plain">&lt;iostream&gt;</span></span> <br/>
<br/>
<span class="keywords">using</span> <span class="keywords">namespace</span> <span class="library">std</span>;<br/><br/>

<span class="functions"><span class="keywords">int</span> <span class="library">main</span><span class="plain">()</span> </span>&#123;<br/>
        <span class="keywords">for</span> (<span class="keywords">int</span> i = <span class="-plain">1</span>; i &lt;= <span class="-plain">5</span>; ++i) &#123;<br/>
        <span class="library">cout</span> &lt;&lt; i &lt;&lt; <span class="-string">" "</span>;<br/>
    &#125;<br/>
    <span class="keywords">return</span> <span class="plain">0</span>;<br/>
&#125;</code><br/>
            </p>
            <h3>Output:</h3>
            <div className='output'>
            1 2 3 4 5

                 </div>
                 <p>Here is how this program works</p>
                 <table border="0">
		<tbody>
			<tr>
				<th>Iteration</th>
				<th>Variable</th>
				<th>i &lt;= 5</th>
				<th>Action</th>
			</tr>
			<tr>
				<td>1st</td>
				<td><code>i = 1</code></td>
				<td><code>true</code></td>
				<td><samp>1</samp> is printed. <code>i</code> is increased to <code>2</code>.</td>
			</tr>
			<tr>
				<td>2nd</td>
				<td><code>i = 2</code></td>
				<td><code>true</code></td>
				<td><samp>2</samp> is printed. <code>i</code> is increased to <code>3</code>.</td>
			</tr>
			<tr>
				<td>3rd</td>
				<td><code>i = 3</code></td>
				<td><code>true</code></td>
				<td><samp>3</samp> is printed. <code>i</code> is increased to <code>4</code>.</td>
			</tr>
			<tr>
				<td>4th</td>
				<td><code>i = 4</code></td>
				<td><code>true</code></td>
				<td><samp>4</samp> is printed. <code>i</code> is increased to <code>5</code>.</td>
			</tr>
			<tr>
				<td>5th</td>
				<td><code>i = 5</code></td>
				<td><code>true</code></td>
				<td><samp>5</samp> is printed. <code>i</code> is increased to <code>6</code>.</td>
			</tr>
			<tr>
				<td>6th</td>
				<td><code>i = 6</code></td>
				<td><code>false</code></td>
				<td>The loop is terminated</td>
			</tr>
		</tbody>
	</table>
    <h3>C++ while Loop</h3>
    <div class="containers"><span class="keywords">while</span> (condition) <br /> &#123; <br />
    <span class="comment">// body of the loop</span> <br />
&#125;</div>
<p>Here,</p>
<ul>
	<li>A <code>while</code> loop evaluates the <code>condition</code></li>
	<li>If the <code>condition</code> evaluates to <code>true</code>, the code inside the <code>while</code> loop is executed.</li>
	<li>The <code>condition</code> is evaluated again.</li>
	<li>This process continues until the <code>condition</code> is <code>false</code>.</li>
	<li>When the <code>condition</code> evaluates to <code>false</code>, the loop terminates.</li>
</ul>
<h3>Example 1: Display plains from 1 to 5</h3>
<div class="containers "><span class="comment">// C++ Program to print plains from 1 to 5</span> <br /><br />

<span class="-meta">#<span class="keywords">include</span> <span class="library">&lt;iostream&gt;</span></span><br /><br />

<span class="keywords">using</span> <span class="keywords">namespace</span> <span class="library">std</span>;<br /><br />

<span class="function"><span class="keywords">int</span> <span class="library">main</span><span class="-params">()</span><br /><br /> </span><br />&#123;
    <span class="keywords">int</span> i = <span class="-plain">1</span>; <br />
    <br />
    <span class="comment">// while loop from 1 to 5</span><br />
    <span class="keywords">while</span> (i &lt;= <span class="-plain">5</span>)<br /> &#123;<br />
        <span class="library">cout</span> &lt;&lt; i &lt;&lt; <span class="-string">" "</span>;<br />
        ++i;<br />
    &#125;<br />
    
    <span class="keywords">return</span> <span class="-plain">0</span>;<br />
    &#125;<br /></div>
    <h3>Output:</h3>
            <div className='output'>
            1 2 3 4 5

                 </div>
                 <table border="0">
		<tbody>
			<tr>
				<th>Iteration</th>
				<th>Variable</th>
				<th>i &lt;= 5</th>
				<th>Action</th>
			</tr>
			<tr>
				<td>1st</td>
				<td><code>i = 1</code></td>
				<td><code>true</code></td>
				<td><samp>1</samp> is printed and <code>i</code> is increased to <code>2</code>.</td>
			</tr>
			<tr>
				<td>2nd</td>
				<td><code>i = 2</code></td>
				<td><code>true</code></td>
				<td><samp>2</samp> is printed and <code>i</code> is increased to <code>3</code>.</td>
			</tr>
			<tr>
				<td>3rd</td>
				<td><code>i = 3</code></td>
				<td><code>true</code></td>
				<td><samp>3</samp> is printed and <code>i</code> is increased to <code>4</code></td>
			</tr>
			<tr>
				<td>4th</td>
				<td><code>i = 4</code></td>
				<td><code>true</code></td>
				<td><samp>4</samp> is printed and <code>i</code> is increased to <code>5</code>.</td>
			</tr>
			<tr>
				<td>5th</td>
				<td><code>i = 5</code></td>
				<td><code>true</code></td>
				<td><samp>5</samp> is printed and <code>i</code> is increased to <code>6</code>.</td>
			</tr>
			<tr>
				<td>6th</td>
				<td><code>i = 6</code></td>
				<td><code>false</code></td>
				<td>The loop is terminated</td>
			</tr>
		</tbody>
	</table>
    <h3>C++ do...while Loop</h3>
    <p>The <code>do...while</code> loop is a variant of the <code>while</code> loop with one important 
    difference: the body of <code>do...while</code> loop is executed once before the <code>condition</code> is
     checked.</p>
     <p>Its syntax is:</p>
     <div class="containers"><span class="keywords">do</span> <br /> &#123; <br />
   <span class="comment">// body of loop;</span> <br />
&#125; <br />
<span class="keywords">while</span> (condition);</div> <br />
<p>Here,</p>
<ul>
	<li>The body of the loop is executed at first. Then the <code>condition</code> is evaluated.</li>
	<li>If the <code>condition</code> evaluates to <code>true</code>, the body of the loop inside the <code>do</code> statement is executed again.</li>
	<li>The <code>condition</code> is evaluated once again.</li>
	<li>If the <code>condition</code> evaluates to <code>true</code>, the body of the loop inside the <code>do</code> statement is executed again.</li>
	<li>This process continues until the <code>condition</code> evaluates to <code>false</code>. Then the loop stops.</li>
</ul>
<h3>Example : Display plains from 1 to 5</h3>
<div class="containers"><span class="comment">// C++ Program to print plains from 1 to 5</span> <br /> <br />

<span class="meta">#<span class="keywords">include</span> <span class="library">&lt;iostream&gt;</span></span> <br /> <br />

<span class="keywords">using</span> <span class="keywords">namespace</span> <span class="library">std</span>; <br /> <br />

<span class="function"><span class="keywords">int</span> <span class="title">main</span><span class="params">()</span> </span>&#123; <br /> <br />
    <span class="keywords">int</span> i = <span class="plain">1</span>;  <br /> <br />

    <span class="comment">// do...while loop from 1 to 5</span> <br /> <br />
    <span class="keywords">do</span> &#123; <br />
        <span class="library">cout</span> &lt;&lt; i &lt;&lt; <span class="library">" "</span>; <br /> 
        ++i; <br /> <br />

    &#125; <br /> <br />
    <span class="keywords">while</span> (i &lt;= <span class="plain">5</span>); <br />
    <br />
    <span class="keywords">return</span> <span class="plain">0</span>; <br />
&#125; <br />
</div>
<h3>Output:</h3>
            <div className='output'>
            1 2 3 4 5

                 </div>
                 <p>Here is how the program works.</p>
                 <div class="table-responsive">
	<table border="0">
		<tbody>
			<tr>
				<th>Iteration</th>
				<th>Variable</th>
				<th>i &lt;= 5</th>
				<th>Action</th>
			</tr>
			<tr>
				<td>&nbsp;</td>
				<td><code>i = 1</code></td>
				<td>not checked</td>
				<td><samp>1</samp> is printed and <code>i</code> is increased to 2</td>
			</tr>
			<tr>
				<td>1st</td>
				<td><code>i = 2</code></td>
				<td><code>true</code></td>
				<td><samp>2</samp> is printed and <code>i</code> is increased to 3</td>
			</tr>
			<tr>
				<td>2nd</td>
				<td><code>i = 3</code></td>
				<td><code>true</code></td>
				<td><samp>3</samp> is printed and <code>i</code> is increased to 4</td>
			</tr>
			<tr>
				<td>3rd</td>
				<td><code>i = 4</code></td>
				<td><code>true</code></td>
				<td><samp>4</samp> is printed and <code>i</code> is increased to 5</td>
			</tr>
			<tr>
				<td>4th</td>
				<td><code>i = 5</code></td>
				<td><code>true</code></td>
				<td><samp>5</samp> is printed and <code>i</code> is increased to <strong>6</strong></td>
			</tr>
			<tr>
				<td>5th</td>
				<td><code>i = 6</code></td>
				<td><code>false</code></td>
				<td>The loop is terminated</td>
			</tr>
		</tbody>
	</table>
</div>
        </div>


    )
}

export default Loopse
